import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-spectrum",
  "use": "icon-spectrum-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-spectrum\"><defs><style type=\"text/css\"></style></defs><path d=\"M576 32v960h120V32H576zM336 152v720h120V152H336z m480 120v480h120V272H816zM96 392v240h120V392H96z\" p-id=\"3011\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol